import { useState, forwardRef } from "react";
import { Input } from "@/components/ui/input";
import { Eye, EyeSlash } from "@phosphor-icons/react";

const PasswordInput = forwardRef(function PasswordInput({ className = "", ...props }, ref) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <Input
        {...props}
        ref={ref}
        type={show ? "text" : "password"}
        className={`pr-10 ${className}`}
      />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        tabIndex={-1}
        aria-label={show ? "Ocultar contrasena" : "Mostrar contrasena"}
        className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-[#CCFF00] transition-colors"
        data-testid={props["data-testid"] ? `${props["data-testid"]}-toggle` : "password-toggle"}
      >
        {show ? <EyeSlash size={18} /> : <Eye size={18} />}
      </button>
    </div>
  );
});

export default PasswordInput;
